import React from 'react';

const WorkSprintsPage = () => {
  return (
    <div>
      <h1>Work Sprints</h1>
    </div>
  );
};

export default WorkSprintsPage;
